import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const OcInfoCardDivider = () => {
  const theme = useTheme();
  return (
    <Box
      style={{
        borderBottom: `1px solid ${theme.palette.gray40.main}`,
        margin: "4px 0px",
      }}
    ></Box>
  );
};

export default OcInfoCardDivider;
